import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/group.svg'


const _withScopeId = n => (_pushScopeId("data-v-16d0b610"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "interest",
  tabindex: "-1",
  "aria-labelledby": "interest",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "fw-bold text-center w-100 fs-5 text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-hand-paper fs-5" }, null, -1))
const _hoisted_6 = { class: "ms-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "px-lg-2 h-500 overflow-auto"
}
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-center fw-bold fs-7 cursor-pointer col-6 col-lg-7"
}
const _hoisted_14 = { class: "text-name" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "fs-7 ms-2 d-flex text-end my-lg-0 flex-lg-row flex-column" }
const _hoisted_18 = { class: "me-lg-2 d-flex align-items-center justify-content-between mb-2 mb-lg-0" }
const _hoisted_19 = { class: "me-2" }
const _hoisted_20 = {
  key: 0,
  "data-bs-dismiss": "modal",
  class: "position-relative"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "group",
  class: "me-2"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-text" }, "チャット", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "group",
  class: "me-2"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode()
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-text" }, "チャット", -1))
const _hoisted_27 = {
  key: 2,
  class: "point_read position-absolute d-flex align-items-center justify-content-center fw-bold text-white"
}
const _hoisted_28 = { class: "modal-footer justify-content-center" }

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Button from '@/components/button/index.vue'
import { numberWithCommas } from '@/constants/common.ts'
import { translate } from '@/languages/i18n'
import { computed, ComputedRef, ref } from 'vue'
import { useStore } from 'vuex'
import { ACCOUNT_STORE, POST_STORE } from '@/store/constants'
import { useRoute } from 'vue-router'
import { ReplayName } from '@/constants/common.ts'
import { Modal } from 'bootstrap'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'
import dayjs from 'dayjs'

type InterestType = {
  chat_link: string
  created_at: string
  family_name: string
  given_name: string
  management_no: string
  user_type: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const modal = ref()
const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)
const data = computed<ComputedRef<Array<InterestType>>>(() => store.getters[POST_STORE.GETTERS.INTEREST]?.interest)
const loading = computed(() => store.getters[POST_STORE.GETTERS.INTEREST]?.loadingPosts)

const postId = computed<ComputedRef<Array<InterestType>>>(() => store.getters[POST_STORE.GETTERS.POST_ID])

const handleShowUser = async (id, userID, userType, is_deleted_in_30_days) => {
  if (userType === 'community_admin' || is_deleted_in_30_days === 2) {
    return
  }
  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))

  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType, isAdmin: true })
  if (showModal.value) {
    await modal.value?.show()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['modal-dialog', _unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params.id}` ? '' : 'modal-lg'])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(translate)('interest')) + " ", 1),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(loading) ? 0 : _unref(numberWithCommas)(_unref(data)?.length)), 1)
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            (!_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      class: _normalizeClass(['py-2 d-flex  overflow-auto align-items-center', index !== _unref(data).length - 1 ? 'border-bottom mb-4' : ''])
                    }, [
                      (item.user_type === 'community_admin')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(UserAliasIcon, {
                              userType: item.user_type
                            }, null, 8, ["userType"]),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(item.display_name), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: () => handleShowUser(_unref(route).params.id, item?.management_no, item?.user_type, item?.is_deleted_in_30_days),
                            class: "d-flex align-items-center fw-bold fs-7 cursor-pointer col-6 col-lg-7"
                          }, [
                            _createVNode(UserAliasIcon, {
                              userType: item.user_type
                            }, null, 8, ["userType"]),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", null, _toDisplayString(item?.management_no + ' ' + _unref(ReplayName)(item?.is_deleted_in_30_days, item?.available, item?.family_name, item?.given_name, item?.user_type)), 1),
                              (item?.user_type == 'alumni' && item?.is_deleted_in_30_days !== 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(`（ ${item?.display_name} ）`), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_15)),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(dayjs)(item?.created_at).format('YYYY/MM/DD HH:mm')), 1),
                          (item?.chat_link)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (item?.user_type === 'community_admin' || _unref(route).path === `/community/communities/${_unref(route).params?.id}/operational_posts`)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: `/community/communities/${_unref(route).params.id}/posts/${_unref(postId)}/admin/chats/${item.chat_link}`,
                                      class: "bg-gray text-decoration-none text-gray rounded-pill px-2 py-1 cursor-pointer d-flex justify-content-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_21,
                                        _hoisted_22,
                                        _hoisted_23
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true),
                                (item?.user_type !== 'community_admin' && _unref(route).path === `/community/communities/${_unref(route).params?.id}/user_posts`)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 1,
                                      to: `/community/communities/${_unref(route).params.id}/${item?.user_type === 'employee' ? 'community-users' : 'alumnus'}/${
                        item?.management_no
                      }/posts/${_unref(postId)}/chats/${item.chat_link}`,
                                      class: "bg-gray text-decoration-none text-gray rounded-pill px-2 py-1 cursor-pointer d-flex justify-content-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_24,
                                        _hoisted_25,
                                        _hoisted_26
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true),
                                (item?.chat_unread_count > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(numberWithCommas)(item?.chat_unread_count)), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              "data-bs-dismiss": "modal",
              type: 'secondary'
            }, null, 8, ["title"])
          ])
        ])
      ], 2)
    ]),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser)
  ], 64))
}
}

})